import React, { useState, useEffect } from 'react';
import { convertToRaw, EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
// import { convertToHTML } from 'draft-convert';
// import draftToHtml from 'draftjs-to-html';
import draftToHtmlPuri from 'draftjs-to-html';
import { Form, Col } from 'react-bootstrap';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import classNames from 'classnames/bind';
import styles from './CKEditor.module.scss';
const cx = classNames.bind(styles);
import { formLabel } from '~/utils/helpers';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import ColorPicker from './ColorPicker';
import './styles.css';
import isEmpty from 'lodash/isEmpty';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import ColorPickerButton from '~/components/ColorPickerButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

function CKEditor({ fieldName, setConvertedContent, description, defaultBgColor, inline, as, sm, className }) {
    const { resetCount } = useFormTab();

    const [editorState, setEditorState] = useState(
        () =>
            isEmpty(description)
                ? EditorState.createEmpty()
                : EditorState.createWithContent(convertFromRaw(description)), // (1)
    );

    //formik (use `useField` b/c Editor does not use <input> and thus cannot be set input id. Using <Field> only when its children is <input>)
    const [, meta, helpers] = useField(fieldName);

    const [bgColor, setBgColor] = useState(() => defaultBgColor || 'lightgray');

    const handleEditorChange = (state) => {
        setEditorState(state);

        convertContentToHTML(state);
    };
    const convertContentToHTML = (state) => {
        const rawContent = convertToRaw(state.getCurrentContent());

        //formik set field value
        helpers.setValue(rawContent);

        const currentContentAsHTML = draftToHtmlPuri(rawContent);
        setConvertedContent(currentContentAsHTML);
    };

    const editorClass = {
        backgroundColor: bgColor,
        padding: '0.3rem',
        border: '1px solid #ccc',
    };

    React.useLayoutEffect(() => setConvertedContent(draftToHtmlPuri(description)), []);

    useResetCKEditor(resetCount, description, setEditorState, setConvertedContent, setBgColor, defaultBgColor);

    return (
        <>
            <Form.Group
                as={as}
                sm={sm}
                className={className}
            >
                <Form.Label className={inline ? 'col-sm-3 col-form-label' : ''}>{formLabel(fieldName)}</Form.Label>

                <div className={inline ? 'col-sm-9' : ''}>
                    <Editor
                        editorState={editorState}
                        onEditorStateChange={handleEditorChange}
                        wrapperClassName={cx('wrapper-class')}
                        // editorClassName={cx('editor-class')}
                        editorStyle={editorClass}
                        toolbarClassName={cx('toolbar-class')}
                        toolbar={{
                            options: ['inline', 'textAlign', 'fontSize', 'colorPicker'],
                            inline: {
                                options: ['bold'],
                            },
                            colorPicker: { component: ColorPicker },
                            fontSize: {
                                options: [6, 7, 8, 9, 10, 11, 12, 13, 14],
                                className: undefined,
                                component: undefined,
                                dropdownClassName: undefined,
                            },
                        }}
                        onBlur={() => {
                            helpers.setTouched(true);
                        }}
                    />

                    <div className="d-flex">
                        <ColorPickerButton
                            label={
                                <button>
                                    <FontAwesomeIcon icon={faPencil} />
                                </button>
                            }
                            color={bgColor}
                            setColor={setBgColor}
                            fieldName={'template.backgroundColor'}
                        />

                        {meta.touched && meta.error && (
                            <Form.Control.Feedback
                                type="invalid"
                                style={{ display: 'block' }}
                            >
                                {meta.error}
                            </Form.Control.Feedback>
                        )}
                    </div>
                </div>
            </Form.Group>
        </>
    );
}

CKEditor.defaultProps = {
    description: null,
    defaultBgColor: null,
    inline: false,
    className: '',
    as: Col,
    sm: 2,
};
CKEditor.propTypes = {
    fieldName: PropTypes.string.isRequired,
    setConvertedContent: PropTypes.func.isRequired,
    description: PropTypes.object,
    defaultBgColor: PropTypes.string,
    inline: PropTypes.bool,
    as: PropTypes.elementType,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    // values: PropTypes.object.isRequired,
};

function useResetCKEditor(resetCount, description, setEditorState, setConvertedContent, setBgColor, defaultBgColor) {
    useEffect(() => {
        if (resetCount === 0) return;

        // clear editor state when "reset" button is clicked.
        const contentState = convertFromRaw(description);
        setEditorState(EditorState.createWithContent(contentState));
        setConvertedContent(draftToHtmlPuri(description));
        setBgColor(() => defaultBgColor || 'lightgray');
    }, [resetCount]);
}

export default CKEditor;

/**Notes */
//(1): create editorState object from `ContentState`. Ref: https://github.com/jpuri/react-draft-wysiwyg/issues/255#issuecomment-1230620549
